import { SITE } from "@/constants/testIds";

export const WhyNow = () => {
  return (
    <section
      id="why-now"
      data-testid={SITE.whyNowSection}
      className="relative py-24 sm:py-32 bg-grain"
      style={{
        background:
          "radial-gradient(ellipse at 50% 0%, hsl(40 60% 35% / 0.10) 0%, transparent 60%), hsl(222 47% 8%)",
      }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <p className="text-xs uppercase tracking-[0.32em] text-primary/90 mb-5">
          Why Now
        </p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-foreground leading-[1.05] tracking-tight text-balance">
          America turns <span className="italic text-primary">250</span>.
          <br />
          The candle answers.
        </h2>

        <div className="gold-rule w-24 mx-auto my-10" />

        <p className="text-foreground/80 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
          In Hebrew, the word for <em className="text-foreground">candle</em> is{" "}
          <span className="font-serif text-primary text-2xl align-middle px-1">
            נר
          </span>{" "}
          <span className="text-foreground/60">(Ner)</span>.
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-border/40 border border-border/40 max-w-2xl mx-auto">
          {[
            { heb: "נ", name: "Nun", val: "50" },
            { heb: "ר", name: "Resh", val: "200" },
            { heb: "= 250", name: "Together", val: "250" },
          ].map((row, i) => (
            <div
              key={i}
              className="bg-background/80 px-6 py-10 flex flex-col items-center gap-2"
            >
              <span className="font-serif text-5xl text-primary leading-none">
                {row.heb}
              </span>
              <span className="text-xs uppercase tracking-[0.22em] text-foreground/55 mt-3">
                {row.name}
              </span>
              <span className="font-serif text-2xl text-foreground/90">
                {row.val}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-12 text-foreground/75 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
          The candle is not a coincidence. It is a coincidence dressed as a
          blessing — a small light that holds memory, gratitude, and
          responsibility in the same flame.
        </p>

        <p className="mt-14 font-serif italic text-2xl sm:text-3xl text-foreground/95 leading-snug text-balance">
          &ldquo;We light the candle. We remember.
          <br />
          We bring the light forward.&rdquo;
        </p>
      </div>
    </section>
  );
};
